import React from "react";
import BaseInnerBlankCardSecondText from "../../sisu/table/BaseInnerBlankCardSecondText.sisu";

const NeoInnerBlankCardSecondText = (props) => {
  return (<BaseInnerBlankCardSecondText custom="subtexto-card-principal" {...props}>
      {props.children}
    </BaseInnerBlankCardSecondText>);
};

export default NeoInnerBlankCardSecondText;